(ns bp-libs.design-system.components.banner
  "Namespace for banners"
  (:require [bp-libs.design-system.components.buttons :refer [Button]]
            [bp-libs.design-system.components.icons :refer [play add-circle thumb-up]]
            [bp-libs.design-system.components.progress :refer [continue-watching-bar]]
            [bp-libs.design-system.components.thumb :refer [thumb]]
            [clojure.string]
            [reagent.core :as r]))

(def ^:private dot "•")

(defn- extra-info
  [component]
  [:div {:class "flex items-center capitalize"} component])

(defn main
  {:storybook {:tags              {:name         "Tags"
                                   :type         {:name "array"}
                                   :defaultValue ["10", "2006", "Suspense, Ação"]
                                   :control      {:type "array"}}
               :description       {:name         "Description"
                                   :type         {:name "string"}
                                   :defaultValue "Quais as consequências mais sombrias de se tornar um dos homens mais poderosos do mundo? Como tensões ideológicas podem afetar uma empresa?"
                                   :control      {:type "text"}}
               :tab-index         {:name         "tab-index, use -1 to disable"
                                   :type         {:type "number"}
                                   :defaultValue 10
                                   :control      {:type "number"}}
               :keep-watching     {:name         "Keep-Watching %"
                                   :type         {:type "number"}
                                   :defaultValue 80
                                   :control      {:type "number"}}
               :keep-watching-time-left {:name         "Keep-Watching Time Left Description"
                                         :type         {:type "string"}
                                         :defaultValue "37 restantes"
                                         :control      {:type "string"}}
               :title                   {:name         "Banner title"
                                         :type         {:name "string"}
                                         :defaultValue "Some title here"
                                         :control      {:type "text"}}
               :subtitle                 {:name         "Banner subtitle"
                                          :type         {:name "string"}
                                          :defaultValue "Some subtitle here"
                                          :control      {:type "text"}}
               :teachers                {:name         "Teachers"
                                         :type         {:name "array"}
                                         :defaultValue ["Laura Branner"]
                                         :control      {:type "array"}}
               :background-thumb-url    {:name         "Background Thumb Url"
                                         :type         {:name "string"}
                                         :defaultValue "https://picsum.photos/800/800"
                                         :control      {:type "text"}}
               :banner-logo-url         {:name         "Banner logo url"
                                         :type         {:name "string"}
                                         :defaultValue "https://picsum.photos/300/340"
                                         :control      {:type "text"}}}}
  [{:keys [tags description background-thumb-url
           banner-logo-url title subtitle
           teachers
           main-button details-button
           tab-index
           hide-banner?
           keep-watching keep-watching-time-left keep-watching-media-description
           on-save-for-later on-like-this player]}]
  (let [logo-loaded?     (r/atom false)
        banner-loaded?   (r/atom false)]
    (fn []
      (let [show-watching?           (pos? keep-watching)
            show-watching-remaining? (seq keep-watching-time-left)
            is-image?                (not (or (nil? banner-logo-url) hide-banner?))
            show-button?             (-> main-button nil? not)]
        [:div {:class ["w-full relative xl:text-base text-lg h-full select-none"
                       "banner-gradient"]}
         [:div {:class "absolute top-0 w-full bg-black z-0 h-full"}
          (when player player)
          (when-not player
            [thumb {:container             {:width "100%" :height "100%"}
                    :image-filter?         true
                    :full-image?           true
                    :on-image-load         #(reset! banner-loaded? true)
                    :square-border?        true
                    :image-filter-position "left"
                    :image-url             background-thumb-url}])]
         [:div {:class "absolute w-[47%] top-0 left-0 h-[80%] flex items-center shink-0 z-10 pl-8"}
          [:div {:class ["w-full h-[80%] flex flex-col place-content-center"
                         "space-y-2"]}
           [:div {:class ["overflow-clip"
                          "mb-4"
                          (if is-image?
                            "max-w-[100%] max-h-[10vh]" ;; use max-height with % here does not work on chrome 65
                            "max-w-[100%] max-h-[30%]")]}
            (if banner-logo-url
              [thumb {:container           {:width "100%" :height "10vh"}
                      :image-fit           "fill"
                      :class               "transition-opacity ease-in duration-500 opacity-100"
                      :on-image-load       #(reset! logo-loaded? true)
                      :hide-image?         hide-banner?
                      :image-url           banner-logo-url}]
              [:div {:class "space-y-2 mb-1"}
               (when (seq subtitle)
                 [:h2 {:class "text-gray-400 text-3xl font-semibold line-clamp-1"} subtitle])
               [:h1 {:class ["text-white text-5xl/[3.4rem] font-semibold"
                             (if (seq subtitle)
                               "line-clamp-1"
                               "line-clamp-2")]} title]])]
           (into [:div {:class ["mb-6"
                                "space-x-2 flex text-gray-400 text-lg max-h-[10%] font-medium"]}]
                 (mapv extra-info
                       (rest (interleave (repeat dot) tags))))
           [:div {:class ["mb-6"
                          "w-[80%] max-w-[80%] max-h-[50%] line-clamp-3 overflow-hidden leading-normal"
                          "text-white text-2xl font-medium"]}
            description]
           (when (seq teachers)
             [:div {:class "inline-flex space-x-2 text-lg font-medium"}
              [:span {:class "text-gray-400"} "Prof"]
              [:span {:class "text-white"} (clojure.string/join ", " teachers)]])
           (when show-button?
             [:div {:class "flex space-x-4"}
              [Button {:color         "black"
                       :react-ref     (:react-ref main-button)
                       :on-key-down   (:on-key-down main-button)
                       :extra-classes ["py-3.5 px-7 outline-none text-lg"]
                       :tab-index     tab-index
                       :on-click      (:on-click main-button)}
               [:span {:class "inline-flex space-x-2 items-center"}
                (when (seq (:icon main-button))
                  [:span {:class "-mx-1"} [play {:variant :square}]])
                [:span {:class "capitalize"} (:title main-button)]]]
              (when details-button
                [Button {:color         "black"
                         :react-ref     (:react-ref details-button)
                         :on-key-down   (:on-key-down details-button)
                         :extra-classes ["py-3.5 px-7 outline-none text-lg"]
                         :tab-index     tab-index
                         :on-click      (:on-click details-button)}
                 [:span "Detalhes"]])
              (when on-save-for-later
                [Button {:color         "black"
                         :tab-index tab-index
                         :rounded-full? true
                         :on-click      on-save-for-later}
                 [add-circle]])
              (when on-like-this
                [Button {:color         "black"
                         :tab-index tab-index
                         :rounded-full? true
                         :on-click      on-like-this}
                 [thumb-up]])])
           (when show-watching?
             ^{:key (hash (str keep-watching keep-watching-media-description))}
             [:div {:class "flex flex-col max-h-[5%] font-medium space-y-3"}
              (when (seq keep-watching-media-description)
                [:span {:class "text-gray-400 text-lg mt-4"} keep-watching-media-description])
              [:div {:class "flex items-center space-x-3"}
               [:div {:class "w-[30%]"}
                [continue-watching-bar {:width keep-watching}]]
               (when show-watching-remaining?
                 [:span {:class "text-gray-400 text-lg"} keep-watching-time-left])]])]]]))))
